<template>
  <div class="card-dialog">
    <el-dialog
      title="管理员划扣"
      :visible="true"
      @close="handleClose"
    >
      <div class="box">
        <div style="display: flex;align-items: center;">
          <div style="width: 90px;text-align: right;">国际运费：</div><div>{{money}}</div>
        </div>
        <div style="display: flex;align-items: center;margin-top: 10px;">
          <div style="width: 90px;text-align: right;">物流公司：</div>
          <div style="width: calc(100% - 90px);">
            <el-select
              style="width: 100%;"
              size="small"
              v-model="logisticsObj"
              value-key="selectId"
              clearable
              placeholder="请选择物流公司"
            >
              <el-option
                v-for="item in logisticsList"
                :key="item.selectId"
                :label="item.selectName"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex;align-items: center;margin-top: 10px;">
          <div style="width: 90px;text-align: right;">
            国际运单号：
          </div>
          <div style="width: calc(100% - 90px);">
            <el-input size="small" v-model="waybillNumber" placeholder="请输入国际运单号"></el-input>
          </div>
        </div>
        <div style="text-align: center">
          <el-button class="search-btn btn-blue" @click="save" :disabled="money === ''">提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "admin-deduct",
    data(){
      return{
        waybillNumber: '', // 国际运单号
        logisticsList: [], // 物流公司数组
        money: '', // 国际运费
        logisticsObj: {},
        info: {}
      }
    },
    props: {
      row: {
        type: Object,
        default: ()=>({})
      }
    },
    mounted() {
      this.getInfo()
    },
    methods: {
      async getInfo(){
        const params = {
          containerBatchNo: this.row.containerBatchNo,
        }
        const res = await this.$http.get('/container/sysGetBill', {params})
        console.log(res)
        this.money = res.data?.data?.receivedAmount || ''
        this.logisticsList = res.data?.data?.logisticsList || []
        this.info = res.data.data
      },
      handleClose(){
        this.$options.cancel('cancel')
      },
      async save(){
        const params = {
          logisticsCompanyId: this.logisticsObj.selectId,
          logisticeCompany: this.logisticsObj.selectName,
          waybillNumber: this.waybillNumber,
          balance: this.info.balance,
          containerBatchNo: this.info.containerBatchNo,
          paymentNumber: this.info.paymentNumber,
          receivedAmount: this.info.receivedAmount,
          logisticsList: this.logisticsList,
        }
        const res = await this.$http.post('/container/sysFBAPayment', params)
        if(res.data.code === 200){
          this.$options.confirm(true)
        }else {
          this.$message({
            type: 'warning',
            message: res.data.message
          })
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .card-dialog {
    ::v-deep .el-dialog {
      width: 460px;
    }

    ::v-deep .el-dialog__header {
      text-align: center;
      padding-bottom: 0;
    }

    .box{
      .el-button{
        width: 100px;
        text-align: center;
        margin: 20px auto 0;
      }
    }
  }
</style>
